// eslint-disable-next-line
// eslint-disable-next-line no-unused-vars
/* eslint-disable */
import axios from "axios";
import { GoogleMap, MarkerF } from "@react-google-maps/api";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";
import { ThemeContext } from "../context/ContextFile";
import Images from "../Pages/Images";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import {
  MdBorderClear,
  MdGroup,
  MdOutlineBedroomParent,
  MdQuestionMark,
} from "react-icons/md";
import BASE_URL from "./auth/Baseurl";
import BtnLoader from "./BtnLoader/BtnLoader";
import { FaShower } from "react-icons/fa";
import Loading from "./loader/Loading";
// import Quill from "../Pages/Quill";
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
import Quill from "../Pages/Quill";
import QuillSecond from "../Pages/QuillSecond";
import { set } from "jodit/esm/core/helpers";
import CancellingPolicy from "./CancellingPolicy";
import CustomPeriod from "./ListingForm/CustomPeriod";
import ListingShema from "./listingschema";
import Bedrooms from "./ListingForm/Bedrooms";
import ExtraService from "./ListingForm/ExtraService";
import Feature from "./ListingForm/Feature";
import AirportForm from "./ListingForm/AirportForm";
import SubmitButton from "./ListingForm/SubmitButton";
import Location from "./ListingForm/Location";
import InstructionEditor from "../Pages/InstructionEditor";
function ListenRight() {
  // Aiport Error start
  const [formErrorsAirport, setFormErrorsAirport] = useState([]);
  const validateFormAirport = () => {
    const errors = formFields?.map((field) => {
      let fieldErrors = {};
      if (!field.airport_name)
        fieldErrors.airport_name = "This field is required.";
      if (!field.identifer) fieldErrors.identifer = "This field is required.";
      if (!field.airport_use)
        fieldErrors.airport_use = "This field is required.";
      if (!field.operation_hours)
        fieldErrors.operation_hours = "This field is required.";
      if (!field.lighting) fieldErrors.lighting = "This field is required.";
      if (!field.ctaf_unicom)
        fieldErrors.ctaf_unicom = "This field is required.";
      if (!field.fuel) fieldErrors.fuel = "This field is required."; // Add fuel validation
      if (!field.parking) fieldErrors.parking = "This field is required."; // Add parking validation
      if (!field.orientation)
        fieldErrors.orientation = "This field is required.";
      if (!field.surface) fieldErrors.surface = "This field is required."; // Add surface validation
      if (!field.condition) fieldErrors.condition = "This field is required."; // Add condition validation
      if (!field.pattern) fieldErrors.pattern = "This field is required."; // Add pattern validation
      if (!field.distance_from_runway)
        fieldErrors.distance_from_runway = "This field is required.";
      if (!field.air_nav) fieldErrors.air_nav = "This field is required."; // Add air_nav validation
      if (!field.ground_Transportation)
        fieldErrors.ground_Transportation = "This field is required.";
      if (!field.ground_transportation)
        fieldErrors.ground_transportation = "This field is required.";
      return fieldErrors;
    });
    setFormErrorsAirport(errors);
    return errors.every((error) => Object.keys(error).length === 0);
  };

  // Aiport Error End

  // features Error start
  const [errorsFeature, setErrorsFeature] = useState([]);
  const validateFieldsFeature = () => {
    const newErrors = blocks?.map((block) => ({
      feature: !block.selectedFeature,
      checkboxes: block.selectedCheckboxes.length === 0,
    }));
    setErrorsFeature(newErrors);
    return !newErrors.some((error) => error.feature || error.checkboxes);
  };
  // features Error start

  // Extra services Error start

  const [errorsExtraService, setErrorsExtraService] = useState([]);
  const validateFieldsExtraServices = () => {
    const newErrors = extraServicePrices.map((service) => ({
      name: !service.name,
      price: !service.price,
      type: !service.type,
      quantity: !service.quantity,
    }));
    setErrorsExtraService(newErrors);
    return !newErrors.some((error) => Object.values(error).includes(true));
  };
  // Extra services Error start
  // Bedrooms Error start

  const [errorsBedrooms, setErrorsBedrooms] = useState([]);
  const validateFieldsBedrooms = () => {
    const newErrors = bedrooms.map((bedroom) => ({
      name: !bedroom.name,
      guest: !bedroom.guest,
      bed: !bedroom.bed,
      type: !bedroom.type,
    }));
    setErrorsBedrooms(newErrors);
    return !newErrors.some((error) => Object.values(error).includes(true));
  };
  // Bedrooms Error start

  const [loading, setLoading] = useState(false);
  const [cancelling, setCancelling] = useState([]);
  const [loaders, setLoaders] = useState(false);
  const [customPeriods, setCustomPeriods] = useState([
    {
      startDate: null,
      endDate: null,
      custom_price: "",
      custom_weekly_price: "",
      custom_price_additional: "",
    },
  ]);
  const [errors, setErrors] = useState({});
  const [errorsWeekend, setErrorsWeekend] = useState({});
  const [errorsGuest, setErrorsGuest] = useState({});
  const [errorsPet, setErrorsPet] = useState({});
  const [formData, setFormData] = useState({
    title: "",
    type_of_space: "",
    listing_type: "",
    dwelling: "",
    no_of_bedroom: "",
    no_of_guest: "",
    no_of_bed: "",
    no_of_bathroom: "",
    no_of_room: "",
    pet_allowed: "",
    size: "",
    is_draft: 0,
    instant_booking: 0,
    unit_of_measure: "",
    addi_info: "",
    nightly: "",
    smoking_allowed: "",
    per: "",
    weekend: "",
    cancellation_policy: "",
    apply_weekend_price: "",
    min_day_booking: "",
    max_day_booking: "",
    weekly_seven_plus: "",
    weekly_thirty_plus: "",
    addi_guest: "",
    addi_guest_price: "",
    price_per_pet: "",
    no_of_pets: "",
    no_of_addi_guest: "",
    party_allowed: "",
    children_allowed: "",
    clean_fee: "",
    clean_fee_daily: "",
    clean_fee_per_stay: "",
    city_fee: "",
    city_fee_daily: "",
    city_fee_per_stay: "",
    security_deposit: "",
    tax: "",
    address: "",
    images: "",
    bedroom_name: "",
    bedroom_guest: "",
    bedroom_type: "",
    bedroom_bed: "",
  });

  const [secondContent, setSecondContent] = useState("");
  const [ids, setIds] = useState([]);

  const validateField = (name, value) => {
    let newErrors = { ...errors };
    let hasErrors = false;

    if (!value) {
      newErrors[name] = "Required";
      hasErrors = true;
    } else {
      delete newErrors[name];
    }
    setErrors(newErrors);
    return { hasErrors, newErrors };
  };
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const inputValue = type === "checkbox" ? (checked ? 1 : 0) : value;

    setFormData((prevState) => ({
      ...prevState,
      [name]: inputValue,
    }));

    validateField(name, inputValue);
    const updatedFormData = { ...formData, [name]: inputValue };
    if ((name === "apply_weekend_price" || name === "weekend") && inputValue) {
      const otherField =
        name === "apply_weekend_price" ? "weekend" : "apply_weekend_price";
      setErrorsWeekend((prevErrors) => ({
        ...prevErrors,
        [otherField]: updatedFormData[otherField]
          ? ""
          : "This field is required when the other is filled.",
        [name]: "",
      }));
    } else if (name === "apply_weekend_price" || name === "weekend") {
      setErrorsWeekend((prevErrors) => ({
        ...prevErrors,
        apply_weekend_price: "",
        weekend: "",
      }));
    }
    const guestFields = ["addi_guest", "no_of_addi_guest", "addi_guest_price"];
    const isAnyGuestFieldFilled = guestFields.some(
      (field) => updatedFormData[field]
    );
    const guestErrors = isAnyGuestFieldFilled
      ? guestFields.reduce(
          (acc, field) => ({
            ...acc,
            [field]: updatedFormData[field]
              ? ""
              : "This field is required when others are filled.",
          }),
          {}
        )
      : guestFields.reduce((acc, field) => ({ ...acc, [field]: "" }), {});

    setErrorsGuest((prevErrors) => ({
      ...prevErrors,
      ...guestErrors,
    }));
    const petFields = ["pet_allowed", "no_of_pets", "price_per_pet"];
    const isAnypetFieldFilled = petFields.some(
      (field) => updatedFormData[field]
    );
    const petErrors = isAnypetFieldFilled
      ? petFields.reduce(
          (acc, field) => ({
            ...acc,
            [field]: updatedFormData[field]
              ? ""
              : "This field is required when others are filled.",
          }),
          {}
        )
      : petFields.reduce((acc, field) => ({ ...acc, [field]: "" }), {});

    setErrorsPet((prevErrors) => ({
      ...prevErrors,
      ...petErrors,
    }));
  };
  const handleInputChangePercentage = (e) => {
    const { name, value } = e.target;
    let inputValue = value.replace("%", "");

    // Only append "%" if the input is not empty
    if (inputValue) {
      inputValue = inputValue + "%";
    }
    setFormData((prevState) => ({
      ...prevState,
      [name]: inputValue,
    }));
  };
  const Navigate = useNavigate();
  const [bedrooms, setBedrooms] = useState([
    { name: "", guest: "", bed: "", type: "" },
  ]);
  // Function to handle input changes
  const [extraServicePrices, setExtraServicePrices] = useState([
    { name: "", price: "", type: "", quantity: "" },
  ]);
  const [errorCustom, setErrorCustom] = useState([]);
  const validateFields = () => {
    const newErrors = customPeriods.map((period) => ({
      startDate: !period.startDate,
      endDate: !period.endDate,
      custom_price: !period.custom_price,
      custom_weekly_price: !period.custom_weekly_price,
      custom_price_additional: !period.custom_price_additional,
    }));

    setErrorCustom(newErrors);
    return !newErrors.some((error) => Object.values(error).includes(true));
  };
  // Multiple Input Two Code End

  // location Error start
  const [formData12, setFormData12] = useState({
    address: "",
    apt_suite: "",
    city: "",
    state: "",
    zipcode: "",
    area: "",
    country: "",
  });
  const [formErrors, setFormErrors] = useState([]);

  const autoCompleteRef = useRef(null);
  const initialLocation = {
    lat: 40.7128,
    lng: -74.006,
  };
  const [selectedLocation, setSelectedLocation] = useState(initialLocation);
  const [drag, setDrag] = useState({ lat: "", lng: "" });

  const validateLocation = () => {
    const errors = {};

    if (!formData12.address) errors.address = "Address is required.";
    if (!formData12.city) errors.city = "City is required.";
    if (!formData12.state) errors.state = "State is required.";
    if (!formData12.zipcode) errors.zipcode = "ZIP/Postal Code is required.";
    if (!formData12.country) errors.country = "Country is required.";

    setFormErrors(errors); // Set initial errors
    return errors;
  };
  // location Error End
  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    let hasErrors = false;
    for (const key in formData) {
      const { hasErrors: fieldHasErrors, newErrors: fieldErrors } =
        validateField(key, formData[key]);
      newErrors[key] = fieldErrors[key];
      hasErrors = hasErrors || fieldHasErrors;
    }
    setErrors(newErrors);
    if (
      validateFieldsFeature() ||
      validateFormAirport() ||
      validateFieldsBedrooms() ||
      validateLocation()
    ) {
      console.log("Form submitted successfully:", customPeriods);
    } else {
      console.log("Validation errors:", errors);
    }
    if (hasErrors) {
      setLoaders(false);
      Swal.fire({
        icon: "error",
        title: "Please complete all required fields.",
      });
      return;
    }
    if (localData?.complete !== "100%") {
      Swal.fire({
        position: "center",
        title:
          "Your listing will be approved once your profile is complete to 100%.",
        showConfirmButton: true,
        timer: 1500,
      });
      setLoaders(false);
      return;
    }
    const valueGet = formData.addi_guest === "1" ? 1 : 0;
    const valueGet1 = formData.children_allowed == "True" ? 1 : 0;
    const valueGet2 = formData.city_fee_daily == "true" ? 1 : 0;
    const valueGet3 = formData.city_fee_per_stay == "false" ? 0 : 1;
    const valueGet4 = formData.clean_fee_daily == "true" ? 1 : 0;
    const valueGet5 = formData.clean_fee_per_stay == "false" ? 0 : 1;
    const valueGet6 = formData.party_allowed == "No" ? 0 : 1;
    const valueGet7 = formData.smoking_allowed == "No" ? 0 : 1;
    const valueGet8 = formData.pet_allowed == "No" ? 0 : 1;

    const Data = new FormData();
    Data.append("house_rule_addi_info", content);
    Data.append("title", formData.title);
    Data.append("ground_transportation", formData.ground_transportation);
    Data.append("description", secondContent);
    Data.append("type_of_space", formData.type_of_space);
    Data.append("listing_type", formData.listing_type);
    Data.append("dwelling", formData.dwelling);
    Data.append("no_of_bedroom", Number(formData.no_of_bedroom));
    Data.append("no_of_guest", formData.no_of_guest);
    Data.append("no_of_bed", Number(formData.no_of_bed));
    Data.append("no_of_bathroom", formData.no_of_bathroom);
    Data.append("no_of_room", formData.no_of_room);
    Data.append("size", formData.size);
    Data.append("instant_booking", formData.instant_booking);
    Data.append("unit_of_measure", formData.unit_of_measure);
    Data.append("addi_info", formData.addi_info);
    Data.append("nightly", formData.nightly);
    Data.append("per", formData.per);
    Data.append("address", formData12?.address);
    Data.append("apt_suite", formData12.apt_suite);
    Data.append("city", formData12.city);
    Data.append("state", formData12.state);
    Data.append("zipcode", formData12.zipcode);
    Data.append("city_fee", formData.city_fee);
    Data.append("city_fee_daily", valueGet2);
    Data.append("is_draft", 0);
    Data.append("city_fee_per_stay", valueGet3);
    Data.append("area", formData12.area);
    Data.append("smoking_allowed", valueGet7);
    Data.append("pet_allowed", valueGet8);
    Data.append("party_allowed", valueGet6);
    Data.append("children_allowed", valueGet1);
    Data.append("security_deposit", formData.security_deposit);
    Data.append("tax", formData.tax);
    Data.append("cancellation_policy", formData.cancellation_policy);
    Data.append("distance_from_runway", formData.distance_from_runway);
    Data.append("min_day_booking", formData.min_day_booking);
    Data.append("max_day_booking", formData.max_day_booking);
    Data.append("country", formData12.country);
    Data.append("weekend", formData.weekend);
    Data.append("addi_guest_price", formData.addi_guest_price);
    Data.append("no_of_addi_guest", formData.no_of_addi_guest);
    Data.append("addi_guest", valueGet);
    Data.append("apply_weekend_price", formData.apply_weekend_price);
    Data.append("weekly_seven_plus", formData.weekly_seven_plus);
    Data.append("weekly_thirty_plus", formData.weekly_thirty_plus);
    Data.append("airport_use", formData.airport_use);
    Data.append("ctaf_unicom", formData.ctaf_unicom);
    Data.append("dimensions", formData.dimensions);
    Data.append("elevation", formData.elevation);
    Data.append("fuel", formData.fuel);
    Data.append("lighting", formData.lighting);
    Data.append("operation_hours", formData.operation_hours);
    Data.append("orientation", formData.orientation);
    Data.append("parking", formData.parking);
    Data.append("pattern", formData.pattern);
    Data.append("surface", formData.surface);
    Data.append("facilities", JSON.stringify(formData.facility));
    Data.append("amenities", JSON.stringify(formData.amenity));
    Data.append("clean_fee_daily", valueGet4);
    Data.append("clean_fee_per_stay", valueGet5);
    Data.append("lat", selectedLocation.lat);
    Data.append("lng", selectedLocation.lng);

    bedrooms?.map((item, index) => {
      Data.append(`bedrooms[${index}][name]`, item?.name);
      Data.append(`bedrooms[${index}][no_of_guest]`, item?.guest);
      Data.append(`bedrooms[${index}][no_of_bed]`, item?.bed);
      Data.append(`bedrooms[${index}][bed_type]`, item?.type);
    });

    images?.map((item, index) => {
      Data.append(`images[${index}]`, item?.file);
    });

    extraServicePrices?.map((item, index) => {
      Data.append(`extra_service_prices[${index}][name]`, item?.name);
      Data.append(`extra_service_prices[${index}][price]`, item?.price);
      Data.append(`extra_service_prices[${index}][type]`, item?.type);
      Data.append(`extra_service_prices[${index}][quantity]`, item?.quantity);
    });

    blocks?.map(
      (item, index) => (
        Data.append(`features[${index}][id]`, item.selectedFeature),
        item.selectedCheckboxes?.map((item1, index1) =>
          Data.append(
            `features[${index}][feature_details][${index1}][id]`,
            item1
          )
        )
      )
    );

    try {
      const response = await axios.post(`${BASE_URL}/listing`, Data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setLoaders(false);
      Swal.fire({
        position: "center",
        html: `
            <div style="display: flex; flex-direction: column; align-items: center;">
<svg
                      viewBox="0 0 1024 1024"
                      height="4em"
                      width="4em"
                      style="margin-bottom: 10px;"
                  >
                      <!-- Outer circle with color #8ec639 -->
                      <path fill="#8ec639" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" />
                      
                      <!-- Check mark with color #A2c66b -->
                      <path fill="#A2c66b" d="M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z" />
                  </svg>
                <p style="margin: 0; font-size: 1.2em;">Profile update successful.</p>
            </div>
        `,
        title:
          "Your changes have been submitted to Admin. Please stand by for approval.",
        showConfirmButton: true,
        timer: 1500,
      });
      Navigate("/");
    } catch (error) {
      setLoaders(false);
      Swal.fire({
        icon: "error",
        title: "Please complete all required fields.",
        text: error?.responsformData?.data?.message,
      });
    }
  };

  const [images, setImages] = useState([]);
  const [formData1, setFormData1] = useState({
    extra_service_prices: [{ name: "", price: "", type: "" }],
  });

  const [blocks, setBlocks] = useState([
    { selectedFeature: "", selectedId: [], selectedCheckboxes: [] },
  ]);
  // map code end //
  const [minValue, setMinValue] = useState(0);
  const [maxValue, setMaxValue] = useState(24);
  const [minValue1, setMinValue1] = useState(2);
  const [maxValue1, setMaxValue1] = useState(17);
  const handleRangeChange = (values) => {
    const [min, max] = values;
    setMinValue(min);
    setMaxValue(max);
  };
  const handleRangeChange1 = (values) => {
    const [min, max] = values;
    setMinValue1(min);
    setMaxValue1(max);
  };

  const [formFields, setFormFields] = useState([
    {
      airport_use: "",
      airport_name: "",
      air_nav: "",
      identifer: "",
      ctaf_unicom: "",
      dimensions: "",
      elevation: "",
      fuel: [],
      lighting: "",
      operation_hours: "",
      orientation: "",
      ground_Transportation: "",
      parking: "",
      pattern: "",
      surface: [],
      ground_transportation: "",
      distance_from_runway: "",
    },
  ]);

  // rules dropdown and Texteditor start //
  const [content, setContent] = useState([]);
  const [editorContent, setEditorContent] = useState("");
  const [selectedValueContent, setSelectedValueContent] = useState("");
  const handleChange = (event) => {
    const value = event.target.value;

    if (value && !content.includes(value)) {
      setContent((prev) => [...prev, value]);
    }
    setSelectedValueContent(value);
  };
  useEffect(() => {
    setEditorContent(content.join("\n"));
  }, [content]);
  // rules dropdown and Texteditor end //

  // rules dropdown and Texteditor start //
  const [instruction, setInstruction] = useState([]);
  const [editorContentInstruction, setEditorContentInstruction] = useState("");
  const [selectedValue, setSelectedValue] = useState("");

  const handleChangeInstruction = (event) => {
    const value = event.target.value;
    if (value && !instruction.includes(value)) {
      setInstruction((prev) => [...prev, value]);
    }
    setSelectedValue(value);
  };
  useEffect(() => {
    setEditorContentInstruction(instruction.join("\n")); // Update editor content with selected instructions
  }, [instruction]);
  // rules dropdown and Texteditor end //
  // Quill End //
  const localData = JSON.parse(localStorage.getItem("data"));
  console.log(localData, "localData");

  const [listingValue, setListingValue] = useState("");

  useEffect(() => {
    const value = localStorage.getItem("listingValue");
    console.log(value, "listingValue");
    setListingValue(value);
  }, []);

  const commentSectionRef = useRef(null);

  const [checkTime, setCheckTime] = useState({
    check_in_after: "",
    check_in_before: "",
  });
  const times = [
    "6:00AM",
    "6:30AM",
    "7:00AM",
    "7:30AM",
    "8:00AM",
    "8:30AM",
    "9:00AM",
    "9:30AM",
    "10:00AM",
    "10:30AM",
    "11:00AM",
    "11:30AM",
    "12:00PM",
    "12:30PM",
    "1:00PM",
    "1:30PM",
    "2:00PM",
    "2:30PM",
    "3:00PM",
    "3:30PM",
    "4:00PM",
    "4:30PM",
    "5:00PM",
    "5:30PM",
    "6:00PM",
    "6:30PM",
    "7:00PM",
    "7:30PM",
    "8:00PM",
    "8:30PM",
    "9:00PM",
  ];

  const handleCheckIn = (e) => {
    const { name, value } = e.target;
    let newFormData = { ...checkTime, [name]: value };

    const checkInIndex = times.indexOf(newFormData.check_in_after);
    const checkOutIndex = times.indexOf(newFormData.check_in_before);

    // Check if both "Check In After" and "Check Out Before" are selected
    if (newFormData.check_in_after && newFormData.check_in_before) {
      // Ensure that "Check In After" is earlier than "Check Out Before"
      if (checkOutIndex >= checkInIndex) {
        Swal.fire({
          text: "Checkout time should be smaller than the check-in time.",
          icon: "error",
        });
        return; // Prevent updating the state if the condition is not met
      }
    }

    setCheckTime(newFormData);
  };

  const labelIcons = {
    Title: "fal fa-id-badge",
    "Number of Guests (N)": "fal fa-user-friends",
    "Number of Bedrooms": "fal fa-bed",
    "Number of Beds (N)": "fal fa-bed",
    "Type of food": "fal fa-utensils",
    "Number of Bathrooms": "fal fa-toilet",
    "Number of Rooms": "fal fa-door-open",
    "Size (N)": "fal fa-ruler",
    "Nightly Price (N)": "fal fa-moon-stars", // Icon for nightly price (moon)
    "Apply Weekend Price": "fal fa-calendar-week", // Icon for apply weekend price (calendar week)
    "Weekend Nightly Price": "fal fa-sun", // Icon for weekend nightly price (sun)
    "Nightly Price (if 7+ nights)": "fal fa-calendar-alt", // Icon for 7+ nights (calendar-alt)
    "Nightly Price (if 30+ nights)": "fal fa-calendar-check", // Icon for 30+ nights (calendar-check)
  };

  const getIconClass = (label) => labelIcons[label] || "fal fa-question-circle";
  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <form onSubmit={handleSubmit} className="grid md:grid-cols-12 gap-4">
            <div className="md:col-span-8">
              <div className="dashboard-title my-4">
                <h3>Add Listing </h3>
              </div>
              <div className="grid grid-cols-1 bg-white p-4 rounded-lg">
                <label className="text-left">Listing Type</label> <br />
                <div className="listsearch-input-item">
                  <select
                    value={formData.listing_type || listingValue}
                    name="listing_type"
                    onChange={handleInputChange}
                    className="nice-select chosen-select no-search-select"
                  >
                    <option disabled value={""}>
                      All categories
                    </option>
                    <option value={"Short-Term Rental"}>
                      Short-Term Rental
                    </option>
                    <option value={"Adventure"}>Adventure </option>
                  </select>
                </div>
              </div>

              <div className="grid grid-cols-1 bg-white p-4 rounded-lg">
                <h3 className="text-xl font-bold text-left">Location</h3>
                <Location
                  loaders={loaders}
                  handleSubmit={handleSubmit}
                  formData12={formData12}
                  setFormData12={setFormData12}
                  autoCompleteRef={autoCompleteRef}
                  selectedLocation={selectedLocation}
                  setSelectedLocation={setSelectedLocation}
                  drag={drag}
                  setDrag={setDrag}
                  formData={formData}
                  formErrors={formErrors}
                  setFormErrors={setFormErrors}
                />
              </div>

              <div
                ref={commentSectionRef}
                className="grid grid-cols-1 bg-white p-4 rounded-lg"
              >
                <h3 className="text-xl font-bold text-center">Media</h3>
                <Images
                  commentSectionRef={commentSectionRef}
                  images={images}
                  setImages={setImages}
                />

                <div className="flex justify-end items-end gap-4">
                  <button className="border border-[#3b4249] font-medium bg-[#8ec639] rounded-md text-white px-8 py-3">
                    {loaders ? (
                      <BtnLoader />
                    ) : (
                      <>
                        Submit <i className="fas fa-sign-out" />
                      </>
                    )}
                  </button>

                  <button className="border border-[#3b4249] font-medium bg-[#8ec639] rounded-md text-white px-8 py-3">
                    {loaders ? <BtnLoader /> : <>Save as Draft</>}
                  </button>
                </div>
              </div>

              <div className="grid md:grid-cols-12 bg-white p-4 rounded-lg gap-4">
                <h3 className="text-xl font-bold text-center md:col-span-12">
                  Information
                </h3>
                <div className="md:col-span-6 text-left">
                  <label>Type of Space</label> <br />
                  <select
                    value={formData.type_of_space}
                    name="type_of_space"
                    onChange={handleInputChange}
                    className={`border border-input px-3 py-3 w-full rounded-md gap-4 items-center ${
                      errors.type_of_space ? "error" : ""
                    }`}
                  >
                    <option disable value="">
                      Select{" "}
                    </option>{" "}
                    <option value="Entire Place">Entire Place</option>
                    <option value="Private Room">Private Room</option>
                    <option value="Shared Room (Requires Admin Approval)">
                      Shared Room (Requires Admin Approval)
                    </option>
                  </select>{" "}
                  <br />
                  {errors.type_of_space && (
                    <span style={{ color: "red" }}>
                      Please select a type of space
                    </span>
                  )}
                </div>
                <div className="md:col-span-6 text-left">
                  <label>Lodging Type</label> <br />
                  <select
                    value={formData.dwelling}
                    name="dwelling"
                    onChange={handleInputChange}
                    className={`border border-input px-3 py-3 w-full rounded-md gap-4 items-center ${
                      errors.dwelling ? "error" : ""
                    }`}
                  >
                    <option disabled value={""}>
                      Lodging Type
                    </option>
                    <option value={"Apt. / Condo / Loft"}>
                      Apt. / Condo / Loft
                    </option>
                    <option value={"Bed & Breakfast"}>Bed & Breakfast</option>
                    <option value={"Cabin"}>Cabin</option>
                    <option value={"Campsite"}>Campsite</option>
                    <option value={"Farm"}>Farm</option>
                    <option value={"Hangar"}>Hangar</option>
                    <option value={"Hangar Home"}>Hangar Home</option>
                    
                    <option value={"House"}>House</option>
                    <option value={"Mansion"}>Mansion</option>
                    <option value={"Novelty"}>Novelty</option>
                    <option value={"RV"}>RV</option>
                    <option value={"RV Pad"}>RV Pad</option>
                    <option value={"Tiny Home"}>Tiny Home</option>
                  </select>{" "}
                  <br />
                  {errors.dwelling && (
                    <span style={{ color: "red" }}>
                      Please select a Lodging
                    </span>
                  )}
                </div>

                <div className="md:col-span-12 text-left">
                  <label>Title</label> <br />
                  <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                    <i className={getIconClass("Title")} />
                    <input
                      type="text"
                      placeholder="Ex. (KSME) Airport Name - Title"
                      name="title"
                      defaultValue=""
                      value={formData.title}
                      onChange={handleInputChange}
                    />
                  </div>
                  {errors.title && (
                    <span style={{ color: "red" }}>{errors.title}</span>
                  )}
                </div>

                <div className="md:col-span-4 text-left">
                  <label>Number of Guests (N)</label>
                  <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                    <i className={getIconClass("Number of Guests (N)")} />
                    <input
                      type="number"
                      placeholder="Number of Guests"
                      name="no_of_guest"
                      value={formData.no_of_guest}
                      onChange={handleInputChange}
                    />
                  </div>
                  {errors.no_of_guest && (
                    <span style={{ color: "red" }}>{errors.no_of_guest}</span>
                  )}
                </div>

                <div className="md:col-span-4 text-left">
                  <label className="inline-flex items-center">
                    Number of Bedrooms
                    <MdQuestionMark
                      onClick={() =>
                        Swal.fire({
                          text: "This is only the bedrooms you are making available to your guests",
                          icon: "question",
                        })
                      }
                      style={{ color: "#8ec639", cursor: "pointer" }}
                    />
                  </label>{" "}
                  <br />
                  <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                    <i className={getIconClass("Number of Bedrooms")} />
                    <input
                      type="number"
                      placeholder="Number of Bedrooms"
                      name="no_of_bedroom"
                      value={formData.no_of_bedroom}
                      onChange={handleInputChange}
                    />
                  </div>
                  {errors.no_of_bedroom && (
                    <span style={{ color: "red" }}>{errors.no_of_bedroom}</span>
                  )}
                </div>

                <div className="md:col-span-4 text-left">
                  <label>Number of Beds (N)</label> <br />
                  <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                    <i className={getIconClass("Number of Beds (N)")} />
                    <input
                      id="no_of_bed"
                      type="number"
                      placeholder="Number of Beds"
                      name="no_of_bed"
                      value={formData.no_of_bed}
                      onChange={handleInputChange}
                    />
                  </div>
                  {errors.no_of_bed && (
                    <span style={{ color: "red" }}>{errors.no_of_bed}</span>
                  )}
                </div>

                {formData?.listing_type || listingValue === "Adventure" ? (
                  <div className="col-md-4">
                    <label>Type of food</label> <br />
                    <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                      <i className={getIconClass("Type of food")} />
                      <input
                        type="number"
                        placeholder="Number of Bedrooms"
                        name="no_of_bedroom"
                        value={formData.no_of_bedroom}
                        onChange={handleInputChange}
                      />
                    </div>
                    {errors.no_of_bedroom && (
                      <span style={{ color: "red" }}>
                        {errors.no_of_bedroom}
                      </span>
                    )}
                  </div>
                ) : null}

                <div className="md:col-span-6 text-left">
                  <label className="inline-flex items-center">
                    Number of Bathrooms
                    <MdQuestionMark
                      onClick={() =>
                        Swal.fire({
                          text: "You can use whole numbers, or decimals for partial bathrooms. Example 2.5 means two and a half bathrooms. A half (.5) bathroom contains a toilet and a sink. A three-quarters (.75) bathroom contains a toilet, sink, and shower without a bathtub.",
                          icon: "question",
                        })
                      }
                      style={{ color: "#8ec639", cursor: "pointer" }}
                    />
                  </label>
                  <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                    <i className={getIconClass("Number of Bathrooms")} />
                    <input
                      type="number"
                      placeholder="Number of Bathrooms"
                      name="no_of_bathroom"
                      value={formData.no_of_bathroom}
                      onChange={handleInputChange}
                    />
                  </div>
                  {errors.no_of_bathroom && (
                    <span style={{ color: "red" }}>
                      {errors.no_of_bathroom}
                    </span>
                  )}
                </div>

                <div className="md:col-span-6 text-left">
                  <label className="inline-flex items-center">
                    Number of Rooms
                    <MdQuestionMark
                      onClick={() =>
                        Swal.fire({
                          text: "Rooms = bedrooms, living rooms, studies, dens, kitchens, and dining rooms that do not share the space with a living room",
                          icon: "question",
                        })
                      }
                      style={{ color: "#8ec639", cursor: "pointer" }}
                    />
                  </label>
                  <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                    <i className={getIconClass("Number of Rooms")} />
                    <input
                      type="number"
                      placeholder="Number of Rooms"
                      name="no_of_room"
                      value={formData.no_of_room}
                      onChange={handleInputChange}
                    />
                  </div>
                  {errors.no_of_room && (
                    <span style={{ color: "red" }}>{errors.no_of_room}</span>
                  )}
                </div>

                <div className="md:col-span-6 text-left">
                  <label>Size (N)</label>
                  <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                    <i className={getIconClass("Size (N)")} />
                    <input
                      type="number"
                      placeholder="Enter numbers only."
                      name="size"
                      value={formData.size}
                      onChange={handleInputChange}
                    />
                  </div>
                  {errors.size && (
                    <span style={{ color: "red" }}>{errors.size}</span>
                  )}
                </div>

                <div className="md:col-span-6 text-left">
                  <label>Unit of Measure (N)</label>
                  <div className="listsearch-input-item">
                    <select
                      value={formData.unit_of_measure}
                      name="unit_of_measure"
                      onChange={handleInputChange}
                      className={`border border-input px-3 py-3 rounded-md gap-4 w-full items-center${
                        errors.unit_of_measure ? "error" : ""
                      }`}
                    >
                      <option value={"ft²"}>ft²</option>
                      <option value={"m²"}>m²</option>
                    </select>{" "}
                    <br />
                    {errors.unit_of_measure && (
                      <span style={{ color: "red" }}>
                        {errors.unit_of_measure}
                      </span>
                    )}
                  </div>
                </div>
                <div className="md:col-span-12 text-left">
                  <label>
                    Description
                    <i className="fal fa-info-circle" />
                  </label>
                </div>
                <div className="md:col-span-12 text-left">
                  <QuillSecond
                    secondContent={secondContent}
                    setSecondContent={setSecondContent}
                  />
                </div>
                <div className="md:col-span-4 text-left">
                  <button className="border border-[#3b4249] font-medium bg-[#54c4d9] rounded-md text-white px-8 py-3">
                    {loaders ? <BtnLoader /> : <>Save as Draft</>}
                  </button>
                </div>
                <div className="md:col-span-4 text-left">
                  <button className="border border-[#3b4249] font-medium bg-[#8ec639] rounded-md text-white px-8 py-3">
                    {loaders ? (
                      <BtnLoader />
                    ) : (
                      <>
                        Submit <i className="fas fa-sign-out" />
                      </>
                    )}
                  </button>
                </div>
              </div>

              <Bedrooms
                bedrooms={bedrooms}
                loaders={loaders}
                setBedrooms={setBedrooms}
                formData={formData}
                errorsBedrooms={errorsBedrooms}
                setErrorsBedrooms={setErrorsBedrooms}
                handleSubmit={handleSubmit}
              />

              <AirportForm
                formFields={formFields}
                setFormFields={setFormFields}
                loaders={loaders}
                formErrorsAirport={formErrorsAirport}
                setFormErrorsAirport={setFormErrorsAirport}
                handleSubmit={handleSubmit}
              />

              <div className="grid md:grid-cols-12 bg-white p-4 rounded-lg gap-4">
                <h3 className="text-xl font-bold text-center md:col-span-12">
                  Pricing
                </h3>
                <div className="md:col-span-6 text-left">
                  <ul className="flex border border-input px-3 py-3 mt-5 rounded-md gap-4 items-center">
                    <input
                      className="instant_check_box"
                      id="check-aaa5"
                      type="checkbox"
                      name="instant_booking"
                      checked={formData.instant_booking === 1}
                      onChange={handleInputChange}
                    />
                    <label htmlFor="check-aaa5">
                      Allow <strong>Touch & Go</strong>{" "}
                      <span style={{ fontSize: "11px" }}>
                        (book instantly)?
                      </span>
                    </label>
                  </ul>
                  {errors.instant_booking && (
                    <span style={{ color: "red" }}>
                      {errors.instant_booking}
                    </span>
                  )}
                </div>

                <div className="md:col-span-6 text-left">
                  <label>Nightly Price (N)</label>
                  <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                    <i className={getIconClass("Nightly Price (N)")} />
                    <input
                      type="number"
                      placeholder="Nightly Price"
                      defaultValue=""
                      name="nightly"
                      value={formData.nightly}
                      onChange={handleInputChange}
                    />
                  </div>
                  {errors.nightly && (
                    <span style={{ color: "red" }}>{errors.nightly}</span>
                  )}
                </div>

                <div className="md:col-span-6 text-left">
                  <label>Apply Weekend Price</label>
                  <select
                    value={formData.apply_weekend_price}
                    onChange={handleInputChange}
                    name="apply_weekend_price"
                    className={`flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full ${
                      errorsWeekend.apply_weekend_price ? "error" : ""
                    }`}
                  >
                    <option disabled value={""}>
                      None
                    </option>
                    <option value={"Friday and Saturday"}>
                      Friday and Saturday
                    </option>
                    <option value={"Saturday and Sunday"}>
                      Saturday and Sunday
                    </option>
                    <option value={"Friday, Saturday and Sunday"}>
                      Friday, Saturday and Sunday
                    </option>
                  </select>
                  {errorsWeekend.apply_weekend_price && (
                    <span style={{ color: "red" }}>
                      {errorsWeekend.apply_weekend_price}
                    </span>
                  )}
                </div>

                <div className="md:col-span-6 text-left">
                  <label className="inline-flex items-center">
                    Weekend Nightly Price
                    <MdQuestionMark
                      onClick={() =>
                        Swal.fire({
                          text: "Enter what price you will charge on weekends, if different from your regular nightly rate.",
                          icon: "question",
                        })
                      }
                      style={{ color: "#8ec639", cursor: "pointer" }}
                    />
                  </label>
                  <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                    <i className={getIconClass("Weekend Nightly Price")} />
                    <input
                      type="number"
                      placeholder="Weekend Nightly Price"
                      defaultValue=""
                      name="weekend"
                      value={formData.weekend}
                      onChange={handleInputChange}
                    />
                  </div>
                  {errorsWeekend.weekend && (
                    <span style={{ color: "red" }}>
                      {errorsWeekend.weekend}
                    </span>
                  )}
                </div>

                <div className="md:col-span-6 text-left">
                  <label className="inline-flex items-center">
                    Nightly Price (if 7+ nights)
                    <MdQuestionMark
                      onClick={() =>
                        Swal.fire({
                          text: "Enter what price you will charge per night if a guest stays for seven or more nights.",
                          icon: "question",
                        })
                      }
                      style={{ color: "#8ec639", cursor: "pointer" }}
                    />
                  </label>
                  <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                    <i
                      className={getIconClass("Nightly Price (if 7+ nights)")}
                    />
                    <input
                      type="number"
                      placeholder="Nightly Price (if 7+ nights)"
                      name="weekly_seven_plus"
                      value={formData.weekly_seven_plus}
                      onChange={handleInputChange}
                      defaultValue=""
                    />
                  </div>
                </div>

                <div className="md:col-span-6 text-left">
                  <label className="inline-flex items-center">
                    Nightly Price (if 30+ nights)
                    <MdQuestionMark
                      onClick={() =>
                        Swal.fire({
                          text: "Enter what price you will charge per night if a guest stays for 30 or more nights.",
                          icon: "question",
                        })
                      }
                      style={{ color: "#8ec639", cursor: "pointer" }}
                    />
                  </label>
                  <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                    <i
                      className={getIconClass("Nightly Price (if 30+ nights)")}
                    />
                    <input
                      type="number"
                      placeholder="Nightly Price (if 30+ nights)"
                      name="weekly_thirty_plus"
                      value={formData.weekly_thirty_plus}
                      onChange={handleInputChange}
                      defaultValue=""
                    />
                  </div>
                </div>

                <div className="md:col-span-4 text-left">
                  <label>Additional Guests Allowed </label>
                  <select
                    value={formData.addi_guest}
                    onChange={handleInputChange}
                    name="addi_guest"
                    className={`flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full ${
                      errorsGuest.addi_guest ? "error" : ""
                    }`}
                  >
                    <option disabled value="">
                      Select
                    </option>
                    <option value={"Yes"}>Yes</option>
                    <option value={"No"}>No</option>
                  </select>
                  {errorsGuest.addi_guest && (
                    <span style={{ color: "red" }}>
                      {errorsGuest.addi_guest}
                    </span>
                  )}
                </div>
                <div className="md:col-span-4 text-left">
                  <label>No. of Additional Guests</label>
                  <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                    <i className="fal fa-users" />
                    <input
                      type="number"
                      placeholder="No. of Addt'l Guests"
                      defaultValue=""
                      name="no_of_addi_guest"
                      value={formData.no_of_addi_guest}
                      onChange={handleInputChange}
                    />
                  </div>
                  {errorsGuest.no_of_addi_guest && (
                    <span style={{ color: "red" }}>
                      {errorsGuest.no_of_addi_guest}
                    </span>
                  )}
                </div>
                <div className="md:col-span-4 text-left">
                  <label>Price Per Additional Guest</label>
                  <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                    <i className="fal fa-dollar-sign" />
                    <input
                      type="number"
                      placeholder="Price Per Addt'l Guest"
                      name="addi_guest_price"
                      value={formData.addi_guest_price}
                      onChange={handleInputChange}
                      defaultValue=""
                    />
                  </div>
                  {errorsGuest.addi_guest_price && (
                    <span style={{ color: "red" }}>
                      {errorsGuest.addi_guest_price}
                    </span>
                  )}
                </div>
                <div className="md:col-span-4 text-left">
                  <label>
                    Pets Allowed
                    <i className="fal fa-clock" />
                  </label>
                  <div className="listsearch-input-item">
                    <select
                      value={formData.pet_allowed}
                      name="pet_allowed"
                      onChange={handleInputChange}
                      data-placeholder="Apartments"
                      className={`flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full ${
                        errorsPet.pet_allowed ? "error" : ""
                      }`}
                    >
                      <option disabled value={""}>
                        Select
                      </option>
                      <option>Yes</option>
                      <option>No</option>
                    </select>
                    {errorsPet.pet_allowed && (
                      <span style={{ color: "red" }}>
                        {errorsPet.pet_allowed}
                      </span>
                    )}
                  </div>
                </div>
                <div className="md:col-span-4 text-left">
                  <label>No. of Pets</label>
                  <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                    <i className="fal fa-users" />
                    <input
                      type="number"
                      placeholder="No. of pets"
                      defaultValue=""
                      name="no_of_pets"
                      value={formData.no_of_pets}
                      onChange={handleInputChange}
                    />
                  </div>
                  {errorsPet.no_of_pets && (
                    <span style={{ color: "red" }}>{errorsPet.no_of_pets}</span>
                  )}
                </div>
                <div className="md:col-span-4 text-left">
                  <label>Price Per Pet</label>
                  <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                    <i className="fal fa-dollar-sign" />
                    <input
                      type="number"
                      placeholder="Price Per Pet"
                      name="price_per_pet"
                      value={formData.price_per_pet}
                      onChange={handleInputChange}
                      defaultValue=""
                    />
                  </div>
                  {errorsPet.price_per_pet && (
                    <span style={{ color: "red" }}>
                      {errorsPet.price_per_pet}
                    </span>
                  )}
                </div>

                <div className="md:col-span-6 text-left">
                  <label>Cleaning Fee (N)</label>
                  <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                    <i className="fal fa-broom" />
                    <input
                      type="number"
                      placeholder="Cleaning Fee"
                      name="clean_fee"
                      value={formData.clean_fee}
                      onChange={handleInputChange}
                      defaultValue=""
                    />
                  </div>
                  {errors.clean_fee && (
                    <span style={{ color: "red" }}>{errors.clean_fee}</span>
                  )}
                </div>
                <div className="md:col-span-6 text-left">
                  <label>Per stay / Daily </label>
                  <select
                    value={formData.clean_fee_daily}
                    name="clean_fee_daily"
                    onChange={handleInputChange}
                    className={`flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full ${
                      errors.clean_fee_daily ? "error" : ""
                    }`}
                  >
                    <option disabled value={""}>
                      Select
                    </option>
                    <option value={"Per stay"}>Per stay </option>
                    <option value={"Daily"}>Daily</option>
                  </select>
                  {errors.clean_fee_daily && (
                    <span style={{ color: "red" }}>
                      {errors.clean_fee_daily}
                    </span>
                  )}
                </div>
                <div className="md:col-span-6 text-left">
                  <label className="inline-flex items-center">
                    City Fee (N)
                    <MdQuestionMark
                      onClick={() =>
                        Swal.fire({
                          text: "Very rare. Please check with your city to see if they have one. In New York City, for example, Guests pay an occupancy tax of 5.875% along with a flat 'hotel unit fee' of $1.50 per unit per day. It is this flat fee that we are referring to when we ask if a City Fee applies. If there isn't one, leave this blank.",
                          icon: "question",
                        })
                      }
                      style={{
                        color: "#8ec639",
                        cursor: "pointer",
                      }}
                    />
                  </label>
                  <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                    <i className="fal fa-city" />
                    <input
                      type="number"
                      placeholder="City Fee"
                      defaultValue=""
                      name="city_fee"
                      value={formData.city_fee}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="md:col-span-6 text-left">
                  <label>Per stay / Daily</label>
                  <select
                    value={formData.city_fee_daily}
                    name="city_fee_daily"
                    onChange={handleInputChange}
                    className={`flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full ${
                      errors.city_fee_daily ? "error" : ""
                    }`}
                  >
                    <option disabled value={""}>
                      Select
                    </option>
                    <option value={"Per stay"}>Per stay </option>
                    <option value={"Daily"}>Daily</option>
                  </select>
                </div>

                <div className="md:col-span-6 text-left">
                  <label className="inline-flex items-center">
                    Tax %
                    <MdQuestionMark
                      onClick={() =>
                        Swal.fire({
                          text: "Please check with your State, County, and City to see what sales tax rates and lodging tax rates, if any, are applied to short-term rentals. FYI: Lodging tax is also known as Hotel Tax, Occupancy Tax, Tourist Tax, Transient Occupancy Tax (TOT), Bed Tax, Visitor Tax, Accommodation Tax, Resort Tax, City Tax, Tourism Levy, and Hospitality Tax, among other names.",
                          icon: "question",
                        })
                      }
                      style={{ color: "#8ec639", cursor: "pointer" }}
                    />
                  </label>
                  <input
                    className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full"
                    type="text"
                    name="tax"
                    value={formData.tax}
                    onChange={handleInputChangePercentage}
                    placeholder="Combined State, County, City & Lodging Tax"
                    defaultValue=""
                  />
                  {errors.tax && (
                    <span style={{ color: "red" }}>{errors.tax}</span>
                  )}
                </div>

                <h4 className="inline-flex items-center md:col-span-12">
                  Set Up Custom Period Pricing{" "}
                  <MdQuestionMark
                    onClick={() =>
                      Swal.fire({
                        text: "Use this section if there is a block of dates that you would like to charge a price different from your regular nightly rate. Some Hosts charge more during the Christmas season, for example. Other Hosts charge less during the wintertime to attract pilots.",
                        icon: "question",
                      })
                    }
                    style={{ color: "#8ec639", cursor: "pointer" }}
                  />
                </h4>

                <CustomPeriod
                  setCustomPeriods={setCustomPeriods}
                  customPeriods={customPeriods}
                  errorCustom={errorCustom}
                  setErrorCustom={setErrorCustom}
                />

                <ExtraService
                  errorsExtraService={errorsExtraService}
                  setErrorsExtraService={setErrorsExtraService}
                  extraServicePrices={extraServicePrices}
                  setExtraServicePrices={setExtraServicePrices}
                  loaders={loaders}
                  handleSubmit={handleSubmit}
                />
              </div>

              <Feature
                blocks={blocks}
                setBlocks={setBlocks}
                ids={ids}
                setIds={setIds}
                loaders={loaders}
                errorsFeature={errorsFeature}
                setErrorsFeature={setErrorsFeature}
                handleSubmit={handleSubmit}
              />

              <div className="grid md:grid-cols-12 bg-white p-4 rounded-lg gap-4">
                <h3 className="text-xl font-bold text-center md:col-span-12">
                  Terms & Rules
                </h3>
                <CancellingPolicy
                  errors={errors}
                  formData={formData}
                  setFormData={setFormData}
                  setCancelling={setCancelling}
                  cancelling={cancelling}
                />

                <div className="md:col-span-6 text-left">
                  <label>Minimum Days of a Booking</label>
                  <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                    <i className="fal fa-calendar-minus" />
                    <input
                      type="text"
                      name="min_day_booking"
                      value={formData.min_day_booking}
                      onChange={handleInputChange}
                      placeholder="Minimum Days of a Booking"
                      defaultValue=""
                    />
                  </div>
                  {errors.min_day_booking && (
                    <span style={{ color: "red" }}>
                      {errors.min_day_booking}
                    </span>
                  )}
                </div>
                <div className="md:col-span-6 text-left">
                  <label>Maximum Days of a Booking</label>
                  <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                    <i className="fal fa-calendar-plus" />
                    <input
                      name="max_day_booking"
                      value={formData.max_day_booking}
                      onChange={handleInputChange}
                      type="text"
                      placeholder="Maximum Days of a Booking"
                      defaultValue=""
                    />
                  </div>
                  {errors.max_day_booking && (
                    <span style={{ color: "red" }}>
                      {errors.max_day_booking}
                    </span>
                  )}
                </div>

                <div className="md:col-span-6 text-left">
                  <label>
                    Check In After
                    <i className="fal fa-clock" />
                  </label>
                  <select
                    value={checkTime.check_in_after}
                    name="check_in_after"
                    onChange={handleCheckIn}
                    data-placeholder="Apartments"
                    className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full"
                  >
                    <option>Select</option>
                    {times.map((time, index) => (
                      <option key={index} value={time}>
                        {time}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="md:col-span-6 text-left">
                  <label>
                    Check Out Before
                    <i className="fal fa-clock" />
                  </label>
                  <select
                    value={checkTime.check_in_before}
                    name="check_in_before"
                    onChange={handleCheckIn}
                    data-placeholder="Apartments"
                    className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full"
                  >
                    <option>Select</option>
                    {times.map((time, index) => (
                      <option key={index} value={time}>
                        {time}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="md:col-span-6 text-left">
                  <label>
                    Smoking Allowed
                    <i className="fal fa-clock" />
                  </label>
                  <div className="listsearch-input-item">
                    <select
                      value={formData.smoking_allowed}
                      name="smoking_allowed"
                      onChange={handleInputChange}
                      data-placeholder="Apartments"
                      className={`flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full ${
                        errors.smoking_allowed ? "error" : ""
                      }`}
                    >
                      <option disabled value={""}>
                        Select
                      </option>
                      <option>Yes</option>
                      <option>No</option>
                    </select>
                    {errors.smoking_allowed && (
                      <span style={{ color: "red" }}>
                        {errors.smoking_allowed}
                      </span>
                    )}
                  </div>
                </div>
                <div className="md:col-span-6 text-left">
                  {formData.smoking_allowed === "Yes" ? (
                    <>
                      <label>Write your conditions here.</label>
                      <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                        <i className="fal fa-briefcase" />
                        <input
                          type="text"
                          placeholder="Write your conditions here."
                        />
                      </div>
                    </>
                  ) : null}
                </div>
                <div className="md:col-span-6 text-left">
                  <label>
                    Pets Allowed
                    <i className="fal fa-clock" />
                  </label>
                  <select
                    value={formData.pet_allowed}
                    name="pet_allowed"
                    onChange={handleInputChange}
                    data-placeholder="Apartments"
                    className={`flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full ${
                      errors.pet_allowed ? "error" : ""
                    }`}
                  >
                    <option disabled value={""}>
                      Select
                    </option>
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                  {errors.pet_allowed && (
                    <span style={{ color: "red" }}>{errors.pet_allowed}</span>
                  )}
                </div>
                <div className="md:col-span-6 text-left">
                  {formData.pet_allowed === "Yes" ? (
                    <>
                      <label>Write your conditions here.</label>
                      <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                        <i className="fal fa-briefcase" />
                        <input
                          type="text"
                          placeholder="Write your conditions here."
                        />
                      </div>
                    </>
                  ) : null}
                </div>
                <div className="md:col-span-6 text-left">
                  <label>
                    Parties Allowed
                    <i className="fal fa-clock" />
                  </label>
                  <select
                    value={formData.party_allowed}
                    name="party_allowed"
                    onChange={handleInputChange}
                    data-placeholder="Apartments"
                    className={`flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full ${
                      errors.party_allowed ? "error" : ""
                    }`}
                  >
                    <option disabled value={""}>
                      Select
                    </option>
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                  {errors.party_allowed && (
                    <span style={{ color: "red" }}>{errors.party_allowed}</span>
                  )}
                </div>
                <div className="md:col-span-6 text-left">
                  {formData.party_allowed === "Yes" ? (
                    <>
                      <label>Write your conditions here.</label>
                      <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                        <i className="fal fa-briefcase" />
                        <input
                          type="text"
                          placeholder="Write your conditions here."
                        />
                      </div>
                    </>
                  ) : null}
                </div>
                <div className="md:col-span-6 text-left">
                  <label>
                    Children Allowed
                    <i className="fal fa-clock" />
                  </label>
                  <select
                    value={formData.children_allowed}
                    name="children_allowed"
                    onChange={handleInputChange}
                    data-placeholder="Apartments"
                    className={`flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full ${
                      errors.children_allowed ? "error" : ""
                    }`}
                  >
                    <option disabled value={""}>
                      Select
                    </option>
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                  {errors.children_allowed && (
                    <span style={{ color: "red" }}>
                      {errors.children_allowed}
                    </span>
                  )}
                </div>
                <div className="md:col-span-6 text-left">
                  {formData.children_allowed === "Yes" ? (
                    <>
                      <label>Write your conditions here.</label>
                      <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                        <i className="fal fa-briefcase" />
                        <input
                          type="text"
                          placeholder="Write your conditions here."
                        />
                      </div>
                    </>
                  ) : null}
                </div>

                {formData.children_allowed === "Yes" ? (
                  <>
                    <div className="md:col-span-12 text-left">
                      <label>
                        Infants ages: {minValue} - {maxValue} months
                      </label>
                      <div className="pt-5">
                        <RangeSlider
                          min={0}
                          max={24}
                          defaultValue={[0, 24]}
                          onInput={handleRangeChange}
                        />
                      </div>
                    </div>

                    <div className="md:col-span-12 text-left">
                      <label>
                        Children ages: {minValue1} - {maxValue1} years
                      </label>
                      <div className="pt-5">
                        <RangeSlider
                          min={2}
                          max={17}
                          defaultValue={[2, 17]}
                          onInput={handleRangeChange1}
                        />
                      </div>
                    </div>
                  </>
                ) : null}
                <div className="md:col-span-12 text-left">
                  <label>
                    Rules
                    <i className="fal fa-clock" />
                  </label>
                  <select
                    name="rule"
                    placeholder="Rules"
                    value={selectedValueContent}
                    onChange={handleChange}
                    className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full"
                  >
                    <option disabled value="">
                      Choose as many rules as you would like. Feel free to edit
                      or add your own.
                    </option>
                    <option value="Quiet Hours: Quiet hours are from [specific time] to [specific time]. Please respect the neighbors.">
                      Quiet Hours: Quiet hours are from [specific time] to
                      [specific time]. Please respect the neighbors.
                    </option>
                    <option value="Respect the Neighborhood: Please be mindful of noise and parking, and respect the property and surrounding community.">
                      Respect the Neighborhood: Please be mindful of noise and
                      parking, and respect the property and surrounding
                      community.
                    </option>

                    <option value="Report Any Damages: Please report any accidental damages immediately. Any unreported damages may result in fees.">
                      Report Any Damages: Please report any accidental damages
                      immediately. Any unreported damages may result in fees.
                    </option>
                    <option value="No Unregistered Guests: Only registered guests listed in the booking are allowed to stay at the property. No additional overnight guests.">
                      No Unregistered Guests: Only registered guests listed in
                      the booking are allowed to stay at the property. No
                      additional overnight guests.
                    </option>
                    <option value="Use of Amenities: Please use all amenities (pool, hot tub, etc.) responsibly. Follow safety rules, and use at your own risk.">
                      Use of Amenities: Please use all amenities (pool, hot tub,
                      etc.) responsibly. Follow safety rules, and use at your
                      own risk.
                    </option>
                    <option value="Cleaning: Please tidy up before checkout. Washing dishes and taking out the trash would be appreciated.">
                      Cleaning: Please tidy up before checkout. Washing dishes
                      and taking out the trash would be appreciated.
                    </option>
                    <option value="Key/Entry Instructions: Guests are responsible for keeping the keys and access codes safe. A fee may apply for lost keys or access codes.">
                      Key/Entry Instructions: Guests are responsible for keeping
                      the keys and access codes safe. A fee may apply for lost
                      keys or access codes.
                    </option>
                    <option value="Trash and Recycling: Guests are required to follow the trash and recycling procedures. Please dispose of garbage properly.">
                      Trash and Recycling: Guests are required to follow the
                      trash and recycling procedures. Please dispose of garbage
                      properly.
                    </option>
                    <option value="Energy Conservation: Please turn off lights, AC/heating, and appliances when not in use.">
                      Energy Conservation: Please turn off lights, AC/heating,
                      and appliances when not in use.
                    </option>
                    <option value="Parking: Parking is limited to [insert number] spaces. Guests are responsible for following the parking rules.">
                      Parking: Parking is limited to [insert number] spaces.
                      Guests are responsible for following the parking rules.
                    </option>
                    <option value="Children: Children are welcome, but supervision is required, especially around [mention any safety concerns like pools or balconies].">
                      Children: Children are welcome, but supervision is
                      required, especially around [mention any safety concerns
                      like pools or balconies].
                    </option>
                    <option value="Security Cameras: For your safety and security, there are [exterior] cameras monitoring the property.">
                      Security Cameras: For your safety and security, there are
                      [exterior] cameras monitoring the property.
                    </option>
                    <option value="House Access: Guests should only access the areas of the home specified in the listing. Certain parts of the property may be off-limits.">
                      House Access: Guests should only access the areas of the
                      home specified in the listing. Certain parts of the
                      property may be off-limits.
                    </option>
                    <option value="Local Laws: Please adhere to all local laws and regulations during your stay.">
                      Local Laws: Please adhere to all local laws and
                      regulations during your stay.
                    </option>
                  </select>
                </div>
                <div className="md:col-span-12 text-left">
                  <label>Edit Rules</label>
                </div>
                <div className="md:col-span-12 text-left">
                  <Quill
                    setContent={setContent}
                    editorContent={editorContent}
                  />
                </div>

                <div className="md:col-span-12 text-left">
                  <label>
                    Welcome and Instructions - this message will be sent to your
                    guest once the reservation is confirmed and paid.
                    <i className="fal fa-clock" />
                  </label>
                  <select
                    name="rule"
                    placeholder="Rules"
                    value={selectedValue}
                    onChange={handleChangeInstruction}
                    className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full"
                  >
                    <option disabled value={""}>
                      Choose as many instructions as you would like. Feel free
                      to edit or add your own.
                    </option>
                    <option value="We’re delighted to have you stay with us! To make your arrival seamless, here’s everything you need to know:">
                      We’re delighted to have you stay with us! To make your
                      arrival seamless, here’s everything you need to know:
                    </option>
                    <option
                      style={{ fontWeight: "bolder" }}
                      value="1. Check-in Instructions:"
                    >
                      1. Check-in Instructions:
                    </option>
                    <option value="Address: [Insert full address with any special notes, like landmarks].">
                      Address: [Insert full address with any special notes, like
                      landmarks].
                    </option>
                    <option value="Entry Code: Use [insert code] at the front door keypad to unlock. Ensure you press [insert instructions] after entering the code.">
                      Entry Code: Use [insert code] at the front door keypad to
                      unlock. Ensure you press [insert instructions] after
                      entering the code.
                    </option>
                    <option value="Check-in Time: [Insert time, e.g., 3:00 PM].">
                      Check-in Time: [Insert time, e.g., 3:00 PM].
                    </option>
                    <option value="Parking: [Provide parking details, such as designated spots or street parking tips].">
                      Parking: [Provide parking details, such as designated
                      spots or street parking tips].
                    </option>

                    <option
                      style={{ fontWeight: "bolder" }}
                      value="2. Wi-Fi Information:"
                    >
                      2. Wi-Fi Information:
                    </option>
                    <option value="Network Name: [Insert Wi-Fi name].">
                      Network Name: [Insert Wi-Fi name].
                    </option>
                    <option value="Password: [Insert password].">
                      Password: [Insert password].
                    </option>

                    <option
                      style={{ fontWeight: "bolder" }}
                      value="3. Appliance Use:"
                    >
                      3. Appliance Use:
                    </option>
                    <option value="Thermostat: [Explain how to use it and preferred temperature settings].">
                      Thermostat: [Explain how to use it and preferred
                      temperature settings].
                    </option>
                    <option value="Kitchen Appliances: Feel free to use all appliances. Please ensure the oven and stovetop are turned off after use.">
                      Kitchen Appliances: Feel free to use all appliances.
                      Please ensure the oven and stovetop are turned off after
                      use.
                    </option>
                    <option value="Washer/Dryer: [Insert operating instructions if available for use].">
                      Washer/Dryer: [Insert operating instructions if available
                      for use].
                    </option>

                    <option
                      style={{ fontWeight: "bolder" }}
                      value="4. Emergency Contacts:"
                    >
                      4. Emergency Contacts:
                    </option>
                    <option value="Host Contact: [Insert phone number or message option].">
                      Host Contact: [Insert phone number or message option].
                    </option>
                    <option value="Local Emergency Services: Dial [insert number, e.g., 911].">
                      Local Emergency Services: Dial [insert number, e.g., 911].
                    </option>
                    <option value="Nearest Hospital/Clinic: [Insert address and contact].">
                      Nearest Hospital/Clinic: [Insert address and contact].
                    </option>

                    <option
                      style={{ fontWeight: "bolder" }}
                      value="5. Check-Out Instructions:"
                    >
                      5. Check-Out Instructions:
                    </option>
                    <option value="Check-Out Time: [Insert time, e.g., 11:00 AM].">
                      Check-Out Time: [Insert time, e.g., 11:00 AM].
                    </option>
                    <option value="Cleaning Up: Please leave used towels in the bathroom and ensure all dishes are washed or placed in the dishwasher.">
                      Cleaning Up: Please leave used towels in the bathroom and
                      ensure all dishes are washed or placed in the dishwasher.
                    </option>
                    <option value="Trash: [Insert instructions for trash disposal, e.g., place bags in the outdoor bin].">
                      Trash: [Insert instructions for trash disposal, e.g.,
                      place bags in the outdoor bin].
                    </option>
                    <option value="Keys: [Insert details if a key is used, e.g., leave it in the lockbox or on the counter].">
                      Keys: [Insert details if a key is used, e.g., leave it in
                      the lockbox or on the counter].
                    </option>

                    <option
                      style={{ fontWeight: "bolder" }}
                      value="6. Local Recommendations:"
                    >
                      6. Local Recommendations:
                    </option>
                    <option value="Grocery Stores: [Insert name and distance of the nearest store].">
                      Grocery Stores: [Insert name and distance of the nearest
                      store].
                    </option>
                    <option value="Restaurants: Check out [insert 2-3 restaurant suggestions].">
                      Restaurants: Check out [insert 2-3 restaurant
                      suggestions].
                    </option>
                    <option value="Activities: We recommend [insert local attractions].">
                      Activities: We recommend [insert local attractions].
                    </option>

                    <option
                      style={{ fontWeight: "bolder" }}
                      value="7. Additional Notes:"
                    >
                      7. Additional Notes:
                    </option>
                    <option value="Welcome Basket: Enjoy a small welcome basket with [insert items, e.g., snacks, water bottles].">
                      Welcome Basket: Enjoy a small welcome basket with [insert
                      items, e.g., snacks, water bottles].
                    </option>
                    <option value="Guidebook: There’s a digital or physical guidebook provided with more detailed instructions and recommendations.">
                      Guidebook: There’s a digital or physical guidebook
                      provided with more detailed instructions and
                      recommendations.
                    </option>
                    <option value="Respect Our Neighbors: Please be considerate of our community.">
                      Respect Our Neighbors: Please be considerate of our
                      community.
                    </option>
                    <option value="Thank you for choosing to stay with us! We hope you have a fantastic visit. Feel free to reach out with any questions or concerns.">
                      Thank you for choosing to stay with us! We hope you have a
                      fantastic visit. Feel free to reach out with any questions
                      or concerns.
                    </option>
                  </select>
                </div>
                <div className="md:col-span-12 text-left">
                  <label>Edit Information</label>
                </div>

                <div className="md:col-span-12 text-left">
                  <InstructionEditor
                    setInstruction={setInstruction}
                    editorContentInstruction={editorContentInstruction}
                  />
                </div>

                <div className="md:col-span-12 text-left flex justify-end items-end gap-4">
                  <button className="border border-[#3b4249] font-medium bg-[#54c4d9] rounded-md text-white px-8 py-3">
                    {loaders ? <BtnLoader /> : <>Save as Draft</>}
                  </button>
                  <button className="border border-[#3b4249] font-medium bg-[#8ec639] rounded-md text-white px-8 py-3">
                    {loaders ? (
                      <BtnLoader />
                    ) : (
                      <>
                        Submit <i className="fas fa-sign-out" />
                      </>
                    )}
                  </button>
                </div>
              </div>

              <div className="grid md:grid-cols-12 bg-white p-4 rounded-lg gap-4">
                <h3 className="text-xl font-bold text-center md:col-span-12">
                  Calendar
                </h3>

                <div className="md:col-span-12 text-left flex justify-end items-end gap-4">
                  <button className="border border-[#3b4249] font-medium bg-[#54c4d9] rounded-md text-white px-8 py-3">
                    {loaders ? <BtnLoader /> : <>Save as Draft</>}
                  </button>
                  <button className="border border-[#3b4249] font-medium bg-[#8ec639] rounded-md text-white px-8 py-3">
                    {loaders ? (
                      <BtnLoader />
                    ) : (
                      <>
                        Submit <i className="fas fa-sign-out" />
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>

            <div className="md:col-span-4 text-left">
              <div className="relative md:fixed md:top-40 h-96 w-full">
                <div className="bg-white p-4">
                  <div className="geodir-category-img">
                    <Link
                      to={`/addlisting`}
                      className="geodir-category-img-wrap fl-wrap"
                    >
                      <img
                        style={{
                          width: "300px",
                          height: "250px",
                        }}
                        src={
                          images?.[0]?.file
                            ? URL.createObjectURL(images[0].file)
                            : "images/all/9.jpg"
                        }
                        alt=""
                      />
                    </Link>

                    <div className="absolute bottom-5 z-10 left-4">
                      <h3 className="title-sin_map  font-bold text-xl">
                        <Link to={`/addlisting`} className="text-white">
                          $99
                        </Link>
                      </h3>
                    </div>
                  </div>
                  <div className="listing-rating-count-wrap">
                    <div
                      className="listing-rating card-popup-rainingvis"
                      data-starrating2={5}
                    />
                    <h3 className="title-sin_map text-black text-left text-lg font-bold my-2">
                      <Link to={`/addlisting`} style={{ color: "black" }}>
                        Your title here!
                      </Link>
                    </h3>
                    <div className="map-item">
                      <i
                        style={{ color: "#3b4249" }}
                        className="fal fa-map-marker-alt me-2"
                      />
                      CIty State And Zip Code
                    </div>
                  </div>
                  <div
                    className="geodir-category-location"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Link
                      to={`/addlisting`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <MdOutlineBedroomParent size={20} color="black" />{" "}
                      <p className="text-black">0</p>
                    </Link>
                    <Link
                      to={`/addlisting`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <FaShower size={20} color="black" />
                      <p className="text-black">0</p>
                    </Link>
                    <Link
                      to={`/addlisting`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <MdGroup size={20} color="black" />
                      <p className="text-black">0</p>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </>
      )}
    </>
  );
}

export default ListenRight;
